module.exports = __webpack_public_path__ + "static/W-8IMY-c3e81c535042d6c20f5ccb2459c8fe31.pdf";